import api from './api/api';

const buildReqBody = (enterprise) => ({
  addressLine1: `${enterprise.address ? `${enterprise.address}, ` : ''}${enterprise.number ? `${enterprise.number}, ` : ''}${enterprise.neighborhood ? `${enterprise.neighborhood}` : ''}`,
  addressLine2: enterprise.complement,
  city: enterprise.city,
  document: enterprise.document,
  name: enterprise.name,
  phoneNumber: enterprise.phoneNumber,
  state: enterprise.state,
  totalArea: enterprise.totalArea,
  zipCode: enterprise.zipCode,
});

export const saveEnterprise = async (enterprise) => {
  const reqBody = buildReqBody(enterprise);

  return api.post('/enterprises', reqBody).then((response) => {
    if (response.status === 200) return response.data;
    throw response.rejectException();
  });
};

export const updateEnterprise = async (enterprise, enterpriseId) => {
  const reqBody = buildReqBody(enterprise);

  return api.put(`/enterprises/${enterpriseId}`, reqBody).then((response) => {
    if (response.status === 200) return response.data;
    throw response.rejectException();
  });
};

export const getEnterprises = async () => api.get('/enterprises').then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getEnterprise = async (enterpriseId) => api.get(`/enterprises/${enterpriseId}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const deleteEnterprise = async (enterprise) => api.delete(`/enterprises/${enterprise.id}`).then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getAddressWithCityAndState = (enterprise) => {
  let address = enterprise.addressLine1 ? `${enterprise.addressLine1}. ` : '';
  address += enterprise.city ? `${enterprise.city.name} - ` : '';
  address += enterprise.state ? `${enterprise.state?.code}` : '';
  return address;
};
